import Vue from 'vue'
import confirmTemp from './src/main.vue'


const Confirm = function (options) {
  const ImageViewerConstructor = Vue.extend(confirmTemp)
  let instance = new ImageViewerConstructor({
    el: document.createElement('div'),
    propsData: options
  })
  instance.onClose = function () {
    instance.$el.remove()
  }
  document.body.appendChild(instance.$el)
}

export default Confirm